
var navcount = 0;
// for pocket watch variables
var casevalue;
var indexvalue;
var position; //casefront, openfront
var pocketfront;
var pocketclose;
var pockettype = 'nomain';
var pocketwatch = false;
var currentSlider;
var totalSliders;
var imgtype;
var tempvariant;

// show thumb
function showthumb(){
  var thumb_num = 0;
  $('.product-single__thumbnail').each(function(){
    if($(this).attr('ahref').indexOf($('#pr_sku_ppr').text())== -1){
      $(this).parent().addClass('d-none');
    }
    else{
      $(this).parent().removeClass('d-none');
      thumb_num++;
    }
  });
  if(thumb_num <2){
    $('.thumb-nav-container').addClass('d-none');
  }
  else{
    $('.thumb-nav-container').removeClass('d-none');
  }
}


//change background colour
function productbackground(){
  	var bgcolor =  $('.is-dial .is-selected').attr('data-value');
    $('.product-page').attr('background', bgcolor);
}

// show variants spec
function showspec(){
  $('.spec-value').each(function(){
      if($(this).attr('sku') == $('#pr_sku_ppr').text()){          $(this).show();      }
      else{          $(this).hide();      }
    });
} 

//removepopup
function removepopup(){
  $('.popup-overlay').hide();
  $('.popup-container').hide();
}


// show images

function showimg(flip){


  var imgsku = $('#pr_sku_ppr').text();  
  // console.log('imgsku'+imgsku);

  if(pocketclose && pocketfront){imgtype = 'main' }
  if(!pocketclose && pocketfront){imgtype = 'openfront' }
  if(pocketclose && !pocketfront){imgtype = 'closed' }
  if(!pocketclose && !pocketfront){imgtype = 'openback' }

  
  if(pockettype == 'noback' && !pocketclose){    pocketfront = true;  imgtype = 'openfront';   $('.pocket-back').hide();  }
  else{$('.pocket-back').show(); }
  if(pockettype == 'nomain' && imgtype == 'openback' ){imgtype = 'closed' }
  if(pockettype == 'nomain' && imgtype == 'main' ){imgtype = 'openfront' }


  // console.log('imgtype'+imgtype);

  if ((imgtype == 'openfront' || imgtype == 'openback') && $('.product-page').attr('tag').indexOf('rotate') !== -1) {    $('.product-img-container').addClass('rotate-img'); }
  else{   $('.product-img-container').removeClass('rotate-img');}


  //showing btn text
  switch(imgtype){
    case 'main':  $('.pocket-back .checkbox').prop('checked', false); $('.pocket-open .checkbox').prop('checked', false); break;
    case 'openfront':  $('.pocket-back .checkbox').prop('checked', false); $('.pocket-open .checkbox').prop('checked', true); break;
    case 'closed':  $('.pocket-back .checkbox').prop('checked', true); $('.pocket-open .checkbox').prop('checked', false); break;
    case 'openback':  $('.pocket-back .checkbox').prop('checked', true); $('.pocket-open .checkbox').prop('checked', true); break;
  }
  //showing img


  $('.product-img-container .img_ptw').each(function(){    
    var $element = $(this);   

      if((!$element.closest('.product-page').hasClass('pocket-watch') || $element.attr('data-bgset').indexOf(imgtype) != -1) && $element.attr('data-bgset').replace(/_/g, '-').indexOf(imgsku) != -1 && $element.attr('data-bgset').replace(/_/g, '-').indexOf('attached') == -1){  
        if(flip){$element.addClass('flipping'); }     
        $element.addClass('selected'); 
        setTimeout(function() {
          $element.removeClass('flipping');
        }, 300);
      }
      else{$element.removeClass('selected');}
  });
}

// show config
function showconfig(){
  $('.option-slider').each(function(index){
    $('.config-'+index+' .config-label').text($(this).attr('data-opname')+': ');
    $('.config-'+index+' .config-content').text($(this).find('.nt_name_current').text());
  });
}
// arrow showing & clicking
function hidearrows(){
  $('.option-slider').each(function() {
    //run this function every click

    if ($(this).find('.swatches-select li:not(.nt_unavailable)').length <= 4) {
      $(this).find('.arrow-container').hide();
    }
  });
}

//close config
function closeconfig(){
  $('.config-container').hide(); 
  $('.pro-info').show(); 
  $('.product_title').removeClass('hide-mb'); 
  $('.pocket-open').show(); 
  $('.goto-spec').removeClass('hide-mb');
  showoptions('init');
  $('.addtocart_btn').appendTo('.buttons-container');
}



//show option-slider
  function showoptions(nav){
    $('.option-slider.available').eq(currentSlider).removeClass('visible'); 
    if(nav =='init'){currentSlider = 0;}
    if(nav == 'prev'){ currentSlider--;      }
    if(nav == 'next'){ currentSlider++;    }
    if(nav =='open' && pocketclose){currentSlider = 0;}
    if(nav =='open' && !pocketclose && totalSliders>0){currentSlider = 1;}

    if (currentSlider >= 0 && currentSlider < totalSliders) {

      if (currentSlider == 0) {        
        $('.config-prev').hide();    
        $('.config-next').addClass('w__100');
        $('.config-prev').addClass('w__0'); 
      }
      else{

        $('.config-prev').show().removeClass('w__0'); 
        $('.config-next').removeClass('w__100'); 
      } // Hide prev button on first slide
      
      if (currentSlider == totalSliders-1) { $('.config-next').hide();         $('.config-finish').show(); }
      else{ $('.config-next').show();         $('.config-finish').hide();      }

      $('.option-slider.available').eq(currentSlider).addClass('visible');
      $('.next-option').text(' - select '+$('.option-slider.available').eq(currentSlider + 1).attr('data-opname'));

      if($('.option-slider.available').eq(currentSlider).hasClass('is-dial') && pocketwatch){pocketclose = false;}
      else{pocketclose = true;}
      if(currentSlider == 1 && !pocketwatch){ $('.pro-mid-img').addClass('img-zoom-in')}
      else{ $('.pro-mid-img').removeClass('img-zoom-in')}

      hidearrows();
      showimg(false);
    }

  } 

jQuery(document).ready(function () {

$('body[type="product"] .product a').click(function(e) {      e.preventDefault();  });  

  // popup
  $('.popup-btn').click(function(){
    if($(this).hasClass('product-img-container')){
      imgscr = $(this).find('.selected').attr('imgsrc');
      $('.pop-content').html('<img src="'+imgscr+'">');
    }
    $('.popup-overlay').show();
    $('.popup-container').show();
  });
  $('.popup-overlay').click(removepopup);
  $('.cancel-btn').click(removepopup);
  

  

$('.header-sku').text($('#pr_sku_ppr').text());
function getEofyDiscountPct() {
  return parseInt($('#callBackVariant_ppr').attr('data-eofy-discount'), 10) ||
    parseInt($('#cart-form_ppr').attr('data-eofy-discount'), 10) || 0;
}
function ensureEofyPriceDisplay() {
  var eofyPct = getEofyDiscountPct();
  if (!eofyPct) return;

  var $priceWrap = $('#price_ppr');
  var $price = $priceWrap.find('.current_price');

  if (!$price.length && $priceWrap.length) {
    var plainHtml = $.trim($priceWrap.html());
    if (plainHtml && plainHtml.indexOf('<del>') === -1) {
      $priceWrap.html('<span class="current_price">' + plainHtml + '</span>');
      $price = $priceWrap.find('.current_price');
    }
  }

  if (!$price.length || $price.find('del').length) return;

  var match = $.trim($price.text()).replace(/\s/g, '').match(/[\d,]+(?:\.\d{2})?/);
  if (!match || !window.geckoShopify || !geckoShopify.formatMoney) return;

  var originalCents = Math.round(parseFloat(match[0].replace(/,/g, '')) * 100);
  var saleCents = Math.round(originalCents * (100 - eofyPct) / 100);
  var html = '<del>' + geckoShopify.formatMoney(originalCents) + '</del> <ins>' + geckoShopify.formatMoney(saleCents) + '</ins>';
  $price.html(html).attr('data-t4-price-html', html);
}
function syncCurrentPriceToButton() {
  ensureEofyPriceDisplay();
  var priceHtml = $('#price_ppr .current_price').html();
  if (!priceHtml) {
    priceHtml = $('#price_ppr').html();
  }
  if (priceHtml) {
    $('.current-price').html(priceHtml);
  }
}
function refreshProductPriceIfReady() {
  if (window.geckoShopify && geckoShopify.refreshProductPagePrice && $('#ProductJson-template_ppr').html()) {
    geckoShopify.refreshProductPagePrice('_ppr');
  } else {
    syncCurrentPriceToButton();
  }
}
syncCurrentPriceToButton();
$(document).on('variant:change', syncCurrentPriceToButton);
setTimeout(refreshProductPriceIfReady, 600);
setTimeout(refreshProductPriceIfReady, 1800);
// $('.option-slider-container').prependTo('.config-container');

  
  //on product page
if($('.product-page').length > 0){

  currentSlider = 0;
  pocketfront  = true;
  pocketclose = true;
  $('.config-finish').hide();
  $('.option-slider').each(function(index){
    if($(this).find('li.nt-swatch').length<2 && index != 0){$(this).removeClass('available')}
  });

  totalSliders = $('.option-slider.available').length;

  if($('.product-page').hasClass('pocket-watch')){pocketwatch = true}

  
  $('.pocket-watch .product-img-container .img_ptw').each(function(){ 

    if($(this).attr('data-bgset').indexOf('main') != -1 ) { pockettype = 'noback'} 
    if($(this).attr('data-bgset').indexOf('openback') != -1 && pockettype == 'noback') {  pockettype = 'allimg'}
    
  });
  if(pockettype == 'nomain'){$('.pocket-open').remove();}

  if($('.is-case .nt-swatch:first-child').length !=0){        casevalue = 'Case ' + $('.is-case .nt-swatch:first-child').attr('data-escape');      }
  if($('.is-dial .nt-swatch:first-child').length !=0){        indexvalue = $('.is-dial .nt-swatch:first-child').attr('data-escape');      }
  // if($('.product-page').hasClass('pocket-watch')){$('.option-slider:nth-child(3)').remove()}
  showoptions('init');
  showspec();
  showconfig();
  hidearrows();
  $('.desc-section .gender td:last-child').each(function(){
    if($(this).text().indexOf('Unisex')!=-1){$(this).text('Unisex')}
    if($(this).text().indexOf('Ladies')!=-1){$(this).text('Ladies')}
    if($(this).text().indexOf('Gents')!=-1){$(this).text('Gents')}
  });
  if($('.product-page').attr('tag').indexOf('Hide Dial') != -1){ $('.round-btn[nav="dial"]').attr('hide','yes'); }


  
}
// $('.pocket-watch .product-img-container .img_ptw').each(function(){       
//   if($(this).attr('data-bgset').indexOf('closed') != -1 || $(this).attr('data-bgset').indexOf('back') != -1){  $(this).addClass('flipping');       }

// });

$('.product-single__thumbnail').click(function(){
  var imgthumb = $(this).attr('ahref');
  $('.product-img-container .img_ptw.selected').removeClass('selected');
  $('.product-img-container .img_ptw').each(function(){
    if($(this).attr('imgsrc').replace(/_/g, '-').indexOf(imgthumb)!= -1){
      $(this).addClass('selected');
    }
  });
});

//fade in mask
  $('.colour-options .nt-swatch').click(function(){$('.white-mask').fadeIn(300);});
  
  $('.pro-mid-img .arrow-left').click(function(){
    var selectedDiv = $('.img_ptw.selected');
    selectedDiv.removeClass('selected');
    var prevDiv = selectedDiv.prev('.img_ptw');
    if (prevDiv.length === 0) {
      // If there is no prev div, go back to the first one
      prevDiv = $('.img_ptw').last();
    }
    prevDiv.addClass('selected');
  });
  $('.pro-mid-img .arrow-right').click(function(){ 
    var selectedDiv = $('.img_ptw.selected');
    selectedDiv.removeClass('selected');
    var nextDiv = selectedDiv.next('.img_ptw');
    if (nextDiv.length === 0) {
      // If there is no next div, go back to the first one
      nextDiv = $('.img_ptw').first();
    }
    nextDiv.addClass('selected');
  });


  //config prev and next btns



   
    $('.config-prev').click(function() {  showoptions('prev');  });
    $('.config-next').click(function() {  showoptions('next');  });



//   showspec();
//   productbackground();

//config product
$('.config-btn').click(function(e){   e.preventDefault();   
  $('.config-container').show();   
  $('.pocket-open').hide();  
  $('.pro-info').hide();  
  $('.product_title').addClass('hide-mb'); 
  $('.goto-spec').addClass('hide-mb');
  $('.addtocart_btn').appendTo('.config-container');
  refreshProductPriceIfReady();
});
$('.config-complete').click(closeconfig);
$('.config-finish').click(closeconfig);

    // switch on click
  $('.nt-swatch .real-btn').click(function(){ 

    var slidername = $(this).closest('.option-slider').attr('data-opname');

    
    $(this).closest('.option-slider').find('.nt-swatch').each(function(){$(this).removeClass('selected')});
    $(this).closest('.nt-swatch').addClass('selected');
    casevalue = 'Case '+$('.is-case .nt-swatch.selected').attr('data-escape');
  	indexvalue = $('.is-dial .nt-swatch.selected').attr('data-escape');
    tempvariant = $(this).closest('.option-slider').find('.nt_name_current').text();
    // console.log('casevalue'+casevalue+',  indexvalue'+indexvalue+',  tempvariant'+tempvariant);


    setTimeout(function(){
      if(!pocketwatch){
        showthumb();
      }
      showspec(); showimg(false); showconfig(); hidearrows(); 
      $('.header-sku').text($('#pr_sku_ppr').text());
      refreshProductPriceIfReady();
    }, 100);
  });
  
  $('.is-dial .nt-swatch').click(function(){setTimeout(function(){productbackground();}, 100);  });

  // switch mouse over
  $('.nt-swatch .real-btn').mouseenter(function(){ 
    tempvariant = $(this).closest('.option-slider').find('.nt_name_current').text();
    $(this).closest('.option-slider').find('.nt_name_current').text( $(this).parent().find('.swatch__value_pr').text());
  });
  $('.nt-swatch .real-btn').mouseleave(function(){
    $(this).closest('.option-slider').find('.nt_name_current').text(tempvariant); 
  });


  $('.arrow-container button').click(function(e){ 
    e.preventDefault() 
    if($(this).hasClass('left-arrow')){$(this).closest('.option-slider').find('.swatches-select').animate({scrollLeft: '-=280px'});}
    if($(this).hasClass('right-arrow')){$(this).closest('.option-slider').find('.swatches-select').animate({scrollLeft: '+=280px'});}

  });

  $('.pocket-back').click(function(){
    pocketfront = !pocketfront;
    showimg(true);
  });
  $('.pocket-open').click(function(){
    pocketclose = !pocketclose;
    // if(pocketclose){currentSlider = 0;}
    // else{currentSlider = 1;}
    showoptions('open');
    showimg(false);
  });

  // Smooth scrolling to anchor links
  $('.smooth-scroll').click(function(event) {
    event.preventDefault(); // Prevent default link behavior
    var target = $(this).attr('href'); // Get the target section ID from the href attribute
    var offset = $(target).offset().top; // Get the top position of the target section

    // Animate the scroll to the target section smoothly
    $('html, body').animate({ scrollTop: offset }, 800, 'swing');
  });

  $('.swatches-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    variableWidth: true
  });
  //hide related collection
  $('a[href="/collections/relatedproducts"]').closest('.cat_space_item').hide();
  $('ul.swatches-select').each(function(){
        $(this).find('li').each(function(index){if(index == 0){ $(this).addClass('selected');}   });
  });

      $('.pocket-watch .product-img-container .img_ptw').each(function(index){         
        if(index == 0){ $(this).addClass('selected');}        
        else{$(this).removeClass('selected');}
      });
      
    $('.pr_sticky_content').css('visibility', 'visible');



});

$(window).on("load", function() {

  if($('.product-page').length > 0){
 
    $("html, body").animate({ scrollTop: $('#nt_content').offset().top }); 


    //show avaiable img
    var avfound = false;
    var avimgfound = false;
    var avsku = 'no product available';
    $('#product-select_ppr  option').each(function(){
     
      if(!$(this).hasClass('nt_sold_out') && !avfound){
        avsku = $(this).attr('sku');
        // console.log('av:'+avsku);

        // console.log($('.product-img-container .img_ptw.selected').attr('imgsrc').replace(/_/g, '-') + ' sku:'+$(this).attr('sku'));

          $('.product-img-container .img_ptw.selected').removeClass('selected');
          $('.product-img-container .img_ptw').each(function(){
            if($(this).attr('imgsrc').replace(/_/g, '-').indexOf(avsku)!= -1 && !avfound){
              $(this).addClass('selected');
              avfound = true;
            }
          });

        
      }


    });
    // $('.multi-images .img_ptw').each(function(index){
    //   if(index ==0){$(this).addClass('selected');}
    //   else{$(this).removeClass('selected');}
    // });
  }


  setTimeout(function(){
  $('.mb_nav_tabs .mb_nav_title[data-id="#shopify-section-mb_nav_js"] span').text('Shop');
  $('.mb_nav_tabs .mb_nav_title[data-id="#shopify-section-mb_cat_js"] span').text('Information');
  }, 1000);
  $('.white-mask').fadeOut(500);
});